import ReactEDSWrapper from '../../../utils/react-eds-wrapper';
import { Button, Dialog } from '@dsi/react-eds';
import styles from '../swgw-scanning/SwgwScanning.module.css';
import { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useLoader } from '../../../hooks/useLoader';
import api from '../../../api/axiosInstance';
import { useSwobNotifications } from '../../../hooks/NotificationsProvider';
import { AxiosError } from 'axios';

export interface DeleteImagePathTagDialogProps {
  repositoryId: string;
  open: boolean;
  item: { image_path: string; tag: string } | null;
  onDelete: () => void;
  onCancel: () => void;
}

const DeleteImagePathTagDialog: React.FC<DeleteImagePathTagDialogProps> = ({ repositoryId, open, item, onDelete, onCancel }) => {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  const { addNotifications } = useSwobNotifications();
  const { showLoader, hideLoader } = useLoader();

  const deleteImagePathTag = async () => {
    showLoader();
    try {
      await api.delete(`/api/jfrog-config/${repositoryId}/image-path-tags`, {
        data: {
          imagePathTags: [{
            image_path: item?.image_path,
            tag: item?.tag
          }]
        }
      });
      onDelete();
      addNotifications([
        {
          title: 'Success',
          icon: 'icon-success',
          description: `Image path ${item?.image_path} with tag ${item?.tag} was successfully deleted.`,
          timestamp: new Date(),
          color: 'green',
        },
      ]);
    } catch (error: unknown) {
      let errorMsg = `An error occurred while deleting the image path ${item?.image_path}.`;
      if (error instanceof AxiosError) {
        errorMsg = error?.response?.data?.message || error?.message;
      }
      addNotifications([
        {
          title: 'Error',
          icon: 'icon-triangle-warning',
          description: errorMsg,
          timestamp: new Date(),
          color: 'red',
        },
      ]);
      onCancel();
    } finally {
      setTimeout(() => {
        hideLoader();
      }, 500);
    }
  };

  return ReactDOM.createPortal(
    <ReactEDSWrapper
      component={Dialog}
      show={open}
      onClose={onCancel}
      title="Remove Image Path & Tag"
      subtitle="JFrog Artifactory Configuration"
      bottom={
        <ReactEDSWrapper
          component={Button}
          variant="primary"
          className="btn primary"
          type="button"
          onClick={deleteImagePathTag}
        >
          Remove Image Path & Tag
        </ReactEDSWrapper>
      }
    >
      <div className={styles.whiteText}>
        You're about to remove image path <strong>{item?.image_path}</strong> with tag <strong>{item?.tag}</strong> from the list.<br />
        This action is permanent and cannot be undone.<br /><br />
        Are you sure you want to continue?
      </div>
    </ReactEDSWrapper>, document.body
  );
};

export default DeleteImagePathTagDialog;
